<template>
  <!-- <f7-page class="EditContact"> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

      <div class="layoutTop"/>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <div class="panel21 panel-default">

        <div class="panel-heading">
            <h4 class="content-block labelAccordionForm">
                <i class="fa fa-address-book formIcon"></i>
                  {{ $t('common.edit_item',
                    {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
            </h4>
        </div>

        <ul>
          <div class="accordion-item accordionForm accordion-item-expanded">
              <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                <div class="item-inner" :class='colorBottomButton'>
                  <div class="form-group row justify-content-start">
                      <div class="item-title createInvoiceBand col-sm-auto text-uppercase">
                        {{ $t('common.formsSubTitle.item_info',
                          {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                        <i class="f7-icons formChevron">chevron_right</i>
                      </div>
                  </div>
                </div>
              </a>

              <div class="accordion-item-content">
                <div class="form-group">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="defaultInline1" name="inlineDefaultRadiosExample" value="1" v-model="typeContact" checked>
                    <label class="custom-control-label" for="defaultInline1">{{ $t('common.indiv') }}</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="defaultInline2" name="inlineDefaultRadiosExample" value="2" v-model="typeContact">
                    <label class="custom-control-label" for="defaultInline2">{{ $t('common.cmpny') }}</label>
                  </div>
                </div>
               <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.nme') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="name" class="form-control" type="text" :placeholder="$i18n.t('common.nme')" v-model="username"></input>
                   </div>
               </div>
               <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.als') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="alias" class="form-control" :placeholder="$i18n.t('common.als')" type="text" v-model="label"></input>
                  </div>
               </div>
               <div class="form-group row typeInd" v-if="typeContact === '1'"
               @click="hideBlock($event)">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.eml_adrs') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="identifier" class="form-control" type="email" :placeholder="$i18n.t('common.eml_adrs')" v-model="identifier"></input>
                   </div>
               </div>
               <div class="form-group row typeCom" v-else
               @click="hideBlock($event)">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.srn') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="identifier" class="form-control" type="text" :placeholder="$i18n.t('common.srn')" v-model="identifier"></input>
                   </div>
               </div>
             </div>
           </div>
         </ul>

         <hr>

         <ul>
           <div class="accordion-item accordionForm accordion-item-expanded">
               <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                 <div class="item-inner" :class='colorBottomButton'>
                   <div class="form-group row justify-content-start">
                       <div class="item-title createInvoiceBand col-sm-auto">
                         {{ $t('common.formsSubTitle.bank_info') }}
                         <i class="f7-icons formChevron">chevron_right</i>
                       </div>
                   </div>
                 </div>
               </a>

              <div class="accordion-item-content">
                <div class="form-group row">
                  <div class="col-sm-2 col-4 col-form-label labelAccordionForm">
                    {{ $t('common.act') }}
                  </div>
                  <div class="col-sm-4 showSmallScreenOnly form-group">
                    <div @click="countriesPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                      {{ $t('common.slct') }}
                    </div>
                  </div>
                  <div class="col-sm-12 showSmallScreenOnly">
                    <input
                      @click="countriesPicker($event)"
                      class="form-control"
                      id="ListCountry"
                      type="text"
                      v-model="zoneCode"
                      :placeholder="$i18n.t('zoneCodes.slct_zone')"
                      readonly>
                    </input>
                  </div>
                  <div class="col-sm-10 showLargeScreenOnly">
                    <select class="form-control" id="sel4" readonly v-model="zone">
                      <option value="" selected hidden>{{ $t('zoneCodes.slct_zone') }}</option>
                      <option v-for="country in countries"
                        :key="country.label"
                        :value="country"
                        :disabled="country.disabled"
                        :selected="country.selected">
                        {{ $t('zoneCodes.' + country.label)}}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="form-group row"
                  v-for="accountLabel in zone.accountLabel">
                    <label class="col-4 col-sm-2 col-form-label">
                      <span class="color-red">* </span>{{ $t(accountLabel) }}</label>
                    <div class="col-8 col-sm-10">
                      <input
                        name="identifier"
                        class="form-control"
                        type="text"
                        :placeholder="$i18n.t(accountLabel)"
                        v-model="zone.values[accountLabel]">
                      </input>
                    </div>
                </div>

               <div v-if="this.$engine.user.currentService.id === '2'">
                 <div class="form-group row">
                   <label class="col-4 col-sm-2 col-form-label">{{ $t('bank_accounts.mandat_id') }}</label>
                   <div class="col-8 col-sm-10">
                     <input name="mandatId" class="form-control" type="text" :placeholder="$i18n.t('bank_accounts.mandat_id')"></input>
                   </div>
                 </div>
                 <div class="form-group row">
                   <label class="col-sm-2 col-4 col-form-label labelAccordionForm">
                     {{ $t('bank_accounts.mandat_date') }}
                   </label>
                   <div class="col-8 col-sm-10">
                     <input class="form-control" type="date" :placeholder="$i18n.t('bank_accounts.mandat_date')">
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </ul>

         <hr>

         <ul>
           <div class="accordion-item accordionForm accordion-item-expanded">
               <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                 <div class="item-inner" :class='colorBottomButton'>
                   <div class="form-group row justify-content-start">
                       <div class="item-title createInvoiceBand col-sm-auto">
                         {{ $t('common.formsSubTitle.extra_info') }}
                         <i class="f7-icons formChevron">chevron_right</i>
                       </div>
                   </div>
                 </div>
               </a>

              <div class="accordion-item-content">
                 <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.phn') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="phoneNumber" class="form-control" type="text" :placeholder="$i18n.t('common.phn')" v-model="phoneNumber"></input>
                   </div>
                 </div>
                 <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.adrs') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="address" class="form-control" type="text" :placeholder="$i18n.t('common.adrs')" v-model="address"></input>
                   </div>
                 </div>
                 <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.cty') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="city" class="form-control" type="text" :placeholder="$i18n.t('common.cty')" v-model="city"></input>
                   </div>
                 </div>
                 <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.zp_code') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="zipCode" class="form-control" type="text" :placeholder="$i18n.t('common.zp_code')" v-model="zipCode"></input>
                   </div>
                 </div>
                 <div class="form-group row">
                   <label class="col-5 col-sm-2 col-form-label">{{ $t('common.ctry') }}</label>
                   <div class="col-7 col-sm-10">
                     <input name="cuntry" class="form-control" type="text" :placeholder="$i18n.t('common.ctry')" v-model="country"></input>
                   </div>
                 </div>
               </div>
             </div>
           </ul>
        </div>
      </div>
    </div>
    <div class="row" :class='colorBottomButton'>
      <div class="col-md-2 offset-md-9">
        <button round class="button-action firstButtonMarginTop" @click="changeContact">
          <i class="icon fa fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
    </div>
  </div>

  <!-- </f7-page> -->
</template>

<script>
import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'
import {createForeignIban, extractForeignIban} from '@/helpers/format'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'EditContact',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      id: '',
      identifier: '',
      username: '',
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: {},
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.typeContact = this.$settings.currentContact.typeContact
    this.zone = this.$engine.bankAccounts.getZoneData(this.$settings.currentContact.zoneCode)
    this.zoneCode = this.zone.label

    /** TLV 19/03/2020
    * On extrait les donn�es du faux IBAN en base en vraies donn�es bancaires,
    * en fonction du pays, dans une variable locale appel�e extractedBankData
    */
    let extractedBankData = {}
    if (this.zoneCode !== '' && this.$settings.currentContact.iban !== '') {
      extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zoneCode)
    }
    /** TLV 19/03/2020
    * On cr�� une variable locale json, qui va �tre int�gr�e dans this.zone et dans that.countries,
    * qui contient les valeurs actuelles du json pour l'utilisateur s�lectionn�
    */
    let datavalues = {}
    for (var bankData in extractedBankData) {
      datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
    }
    this.zone.values = datavalues
    let that = this
    let label = []
    that.countries = this.$engine.bankAccounts.getZoneCode()
    for (var country in that.countries) {
      if (that.countries[country].label === this.zoneCode) {
        that.countries[country].values = datavalues
      }
    }
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = that.countries.filter(function (country) {
          return country.label === p.value[0]
        })[0]
      }
    })
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    changeContact () {
      const that = this

      // Check input formats
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        }
      }

      if (this.identifier.length > 0 && this.typeContact === '1') {
        if (validateEmail(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.eml_adrs')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.eml_adrs')})
          )
          return
        }
      }
      if (this.identifier.length > 0 && this.typeContact === '2') {
        if (validateSIREN(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.srn')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.srn')})
          )
          return
        }
      }
      if (this.phoneNumber.length > 0) {
        if (validatePhoneNumber(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.phn_nbr')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.phn_nbr')})
          )
        }
      }
      if (that.username.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      if (that.label.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }

      /* TLV 18/03/2020
      * Cr�ation d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit contact
      this.$engine.contacts.update({
        idContact: this.id,
        identifier: this.identifier,
        name: this.username,
        iban: localIban,
        label: this.label,
        phoneNumber: this.phoneNumber,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        typeContact: this.typeContact,
        zoneCode: this.zone.label
      })
      .then(() => {
        that.$f7.modal({
          title: that.$i18n.t('success.updated_success',
            {data: that.$i18n.t(that.$engine.services.getLabelIdOne(that.$engine.user.currentService.id))}),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.identifier = ''
          that.username = ''
          that.label = ''
          that.typeContact = '1'
          that.$bus.$emit('refresh-cache-contacts')
          that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>
.container {
    width: 100%;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
/*
ul {
  padding-left: initial;
}*/
</style>



// WEBPACK FOOTER //
// CMEditContact.vue?83ce4aa8